<template>
  <div>
    <modal v-if="true" @close="onCancel" background="">
      <div slot="modal-title">
        Confirmação de senha
      </div>
      <div slot="modal-body" style="background: #eaeaea;">
        <div class="row">
          <div class="col-sm-12">
            <div class="lockscreen-wrapper">
              <div class="lockscreen-name text-center">
                <strong><p>Para continuar você deve confirmar sua senha</p></strong>
                <h4 v-if="nrTentativas < 4">Número de tentaivas: {{ nrTentativas }}</h4>
                {{ usuarioLogado.basic.nome }}
              </div>

              <div class="lockscreen-item">
                <div class="lockscreen-image">
                  <img src="../assets/user.png" alt="User Image" width="128" />
                </div>
                <form class="lockscreen-credentials" @submit.prevent="login">
                  <div class="input-group">
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Senha"
                      v-model="usuario.senha"
                    />

                    <div class="input-group-btn">
                      <button type="submit" class="btn">
                        <i class="fa fa-arrow-right text-muted"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="pull-right" style="padding-right: 5px; padding-bottom: 5px;">
              <button type="button" class="btn btn-default" @click.prevent="onCancel">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from './Modal.vue'
import UsuarioService from '../services/UsuarioService'
import InputSenha from './Inputs/InputSenha.vue'
import Box from './Box.vue'

export default {
  name: 'confirmar-senha',
  data() {
    return {
      usuario: {
        username: '',
        senha: ''
      },
      nrTentativas: 4
    }
  },
  mounted() {
    this.usuario.username = this.usuarioLogado.basic.cpf
  },
  methods: {
    login() {
      UsuarioService.login(this.usuario)
        .then(response => {
          this.$emit('on-success')
        })
        .catch(err => {
          console.error(err)
          this.nrTentativas--
          if (this.nrTentativas === 0) {
            this.$store.dispatch('setUser', {})
            this.$store.dispatch('setCompany', {})
            this.$router.push({ name: 'Login' })
            this.$iziToast.error({
              message: 'Número de tentativas excedidas. Você será deslogado. Bye!',
              timeout: 6000
            })
          } else {
            this.$iziToast.error({ message: 'A senha não confere!', timeout: 6000 })
          }
        })
    },

    // TODO: Refatorar Login original
    // async login2 () {
    //   try {
    //     await UsuarioService.login(this.usuario)
    //     this.$emit('on-success')
    //     if (this.nrTentativas === 0) {
    //       this.$store.dispatch('setUser', {})
    //       this.$store.dispatch('setCompany', {})
    //       this.$router.push({ name: 'Login' })
    //       this.$messages
    //         .error(e.message || e.data.message)
    //         .toast('Número de tentativas excedidas. Você será deslogado. Bye!')
    //       return
    //     }
    //     this.$messages
    //       .error(e.message || e.data.message)
    //       .toast('A senha não confere!')
    //   } catch (e) {
    //     console.error(e)
    //   }
    // },

    onCancel() {
      this.$emit('on-cancel')
    }
  },
  computed: {
    usuarioLogado() {
      return this.$store.getters.getUser
    }
  },
  components: {
    Modal,
    InputSenha,
    Box
  }
}
</script>

<style lang="css"></style>
